'use client';

import { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface TeamMember {
  name: string;
  role: string;
  image: string;
  alt: string;
  bio: string;
  social: {
    linkedin?: string;
    twitter?: string;
    email?: string;
  };
}

export default function TeamSection() {
  const [selectedMember, setSelectedMember] = useState<TeamMember | null>(null);

  const boardMembers: TeamMember[] = [
  {
    name: 'Emma Ekua-Bedua Hudson',
    role: 'Founder & President',
    image: "/assets/images/Screenshot_2026-02-05_at_4.53.09_PM-1770328508639.png",
    alt: 'Professional woman with dreadlocks, glasses, and cream sweater vest',
    bio: 'Ekua is the Founder and President of The Food For Thought Foundation. Under Ekua\'s leadership, The foundation has grown from small collaborative food drives to an organization that creates food supply hubs in the communities we serve in under three years. Ekua\'s experience has made her a leader that can develop concrete solutions for any problem she faces. Her drive allowed her to design, prototype, and build an autonomous vertical farm which has become the main product for our flagship program. Her experience as a guest instructor in the DCPS school system and time as an Education Fellow at KID museum has allowed her to design our interactive, novel curriculum that leverages the value of experiential computer science education. Ms. Hudson\'s experience as a researcher on a National Science Foundation funded project equips her with impact and evaluation skills which she brings to the Foundation. In her professional experience, Ekua has served as a consultant for the National Children\'s Center as an advisor on early learning technology and automated hydroponics. She has been sponsored by the Qualcomm Innovator program, Legacy Lab, and The Clinton Global Initiative University for her commitment to food justice, leadership in the field, and solution she created.',
    social: {
      linkedin: 'https://www.linkedin.com/in/emmaehudson/',
      email: 'ekua@thefoodforthoughtfoundation.org'
    }
  },
  {
    name: 'Maryam (Mary) Bellakbira',
    role: 'Co-Founder & Director of Partnerships and Outreach',
    image: "/assets/images/Screenshot_2026-02-05_at_5.01.12_PM-1770328987457.png",
    alt: 'Maryam Mary Bellakbira professional headshot photo',
    bio: 'Maryam Bellakbira is the Co-Founder and Director of Outreach and Partnerships. In this role, she leads strategic collaborations that expand access, visibility, and real-world impact for the organization. Under her leadership, partnerships with the FFTF team, community leaders, and industry stakeholders have strengthened program reach and accelerated mission-driven growth. A near Cornell University graduate and researcher at Harvard Medical School, Maryam brings a multidisciplinary background spanning biomedical engineering, biotechnology, research, health advocacy, and technology innovation. Her research experience with institutions including Dana Farber, NASA and Stanford. Through her work in advocacy and education, including leadership roles with the United Nations Foundation and nationally recognized initiatives, Maryam has developed a strong ability to build cross-sector partnerships and design programs. Her commitment to innovation, and sustainable impact continues to shape organization\'s growth.',
    social: {
      linkedin: 'https://www.linkedin.com/in/maryambellakbira/',
      email: 'maryam@foodfthought.org'
    }
  },
  {
    name: 'Sara Rintoul',
    role: 'Vice President',
    image: "/assets/images/Screenshot_2026-01-26_at_6.00.22_PM-1769468429568.png",
    alt: 'Sara Rintoul, Vice President of The Food For Thought Foundation',
    bio: 'Sara is the Vice President of The Food For Thought Foundation. She drives the strategy behind how The Food for Thought Foundation builds relationships in the community, brands its products, and manages program operations. Sara\'s experience has made her a visionary that forges pathways for new relationships and alliances. Ms. Rintoul brings program and operations expertise from her time at First Tee managing their youth programs. Her experience managing sports partnerships and marketing for the PGA tour, and currently Proctor and Gamble has led her to craft our brand which helps us reach students, teachers, and community members. In her free time, she serves as a career mentor at the University of Florida.',
    social: {
      linkedin: '#'
    }
  },
  {
    name: 'Isabelle Llabona',
    role: 'Secretary',
    image: "/assets/images/Screenshot_2026-01-26_at_6.01.31_PM-1769468498729.png",
    alt: 'Isabelle Llabona, Secretary of The Food For Thought Foundation',
    bio: 'Isabelle is a graduate of the University of Florida with a degree in Health Sciences in Health Disparities. She was drawn to the Food For Thought Foundation because of its innovative approach to ameliorating food insecurity, which aligns with her personal commitment to holistic healthcare practices. As an aspiring healthcare provider, Isabelle\'s experience as a Patient Care Assistant at UF Health Shands Hospital on the medical-surgical unit, 10-5, has provided her unique medical knowledge that truly informs our organizations strategies. Within the Foundation, she has been a key researcher whose work has furthered organizational resources. Serving as the secretary of the board, she is passionate about promoting our mission via community outreach in the DMV area.',
    social: {
      linkedin: '#'
    }
  },
  {
    name: 'William "Bill" Bellows',
    role: 'External Affairs Committee',
    image: "/assets/images/Screenshot_2026-01-27_at_10.45.36_AM-1769528741216.png",
    alt: 'William Bill Bellows, External Affairs Committee member',
    bio: 'Bellows has been a Professional Lecturer at American University for almost ten years, teaching classes in innovation, entrepreneurship and introduction to business. He also has Co-Directed the American University Incubator for start-up ventures, acting as a business mentor. Prior to joining the Kogod faculty, Professor Bellows was an entrepreneur working in Silicon Valley and Northern Virginia after starting his career in the mainframe and customer marketing divisions at IBM. He was co-founder and managing partner of Copithorne & Bellows, a consulting firm that developed and executed strategy, competitive research, positioning and market outreach programs for Fortune 500 and emerging technology companies. The company was twice named to the Inc. 500 list of the fastest growing private companies in America and was acquired in 1999 by the Omnicom Group. Professor Bellows later served as President, COO and Chief Marketing Officer for three early stage technology companies in Northern Virginia and as a co-founder of a mobile application developer that designed and created information solutions for the World Bank and several European health care agencies.',
    social: {
      linkedin: '#'
    }
  },
  {
    name: 'Duchoma Agoons',
    role: 'External Affairs Committee',
    image: "/assets/images/Screenshot_2026-01-27_at_1.59.36_PM-1769540382859.png",
    alt: 'Duchoma Agoons, External Affairs Committee member',
    bio: 'After completing advanced degrees in analytics and business from prestigious institutions in China and the United States, Agoons embarked on a journey that led him through diverse roles in the corporate world. Notably, he served as a senior advisor and managing partner at Brill English International in Beijing, China, where his expertise in analytics and tailored strategies played a pivotal role in the company\'s growth and global influence. Parallel to his corporate endeavors, Agoons assumed the role of part-time lecturer of Enterprise Strategic Management at North China University of Technology, further showcasing his dedication to shaping future business leaders. Currently, Agoons manages EDU Consulting Service LLC, a small educational consulting firm.',
    social: {
      linkedin: '#'
    }
  },
  {
    name: 'Danielle Vogel',
    role: 'Executive Affairs Committee',
    image: "/assets/images/Screenshot_2026-01-27_at_10.45.59_AM-1769528764010.png",
    alt: 'Danielle Vogel, Executive Affairs Committee member',
    bio: 'Earning her BA from Tufts University and her JD from the Washington College of Law, Vogel began her career with a goal of fighting climate change, working on Capitol Hill in addition to serving as a Trial Attorney within the Environmental Enforcement Section of the U.S. Department of Justice. In 2013, she founded Glen\'s Garden Market, a climate-motivated grocery store in Washington, DC. which created hundreds of jobs and helped launch nearly 100 sustainability oriented small, local food businesses, of which 55 are women-owned and more than 20 were founded by people of color. She also founded a pitch competition called AccelerateHERdc to identify, incubate and accelerate lady-led local businesses, which were making significant and actionable sustainability commitments. Currently, Vogel is a Professional Lecturer at the Kogod School of business, focusing on the intersection between entrepreneurship and sustainability.',
    social: {
      linkedin: '#'
    }
  },
  {
    name: 'Gustavo DeCampos-Abbott',
    role: 'Programs Committee',
    image: "/assets/images/Screenshot_2026-01-27_at_2.02.57_PM-1769540585799.png",
    alt: 'Gustavo DeCampos-Abbott, Programs Committee member',
    bio: 'Gustavo is a University of Maryland and New York University graduate, with an extensive background as a Creative Technologist. Currently, he is both a Lecturer at American University as well as the Design and Build Lab Manager, overseeing the makerspace where Farms For Thought was born. In this role, he supports STEAM research and education while fostering innovative research through problem-based learning, design-thinking, and rapid prototyping. Prior to working at American, he was a consultant on APLU\'s Bill and Melinda Gates Funded Frontier Set Initiative, providing design support throughout the outline, development and launch phases.',
    social: {
      linkedin: '#'
    }
  },
  {
    name: 'Willina Robson',
    role: 'Programs Committee',
    image: "/assets/images/Screenshot_2026-01-27_at_2.10.03_PM-1769541014443.png",
    alt: 'Willina Robson, Programs Committee member with over 10 years of educational leadership experience',
    bio: 'With over 10 years of experience in educational leadership positions, Willina is currently a Senior Director of Academic Programs at District of Columbia Public Schools (DCPS), where she oversees the administration and management of special education programs for students from pre-kindergarten to age 22. With an extensive background in Special Education, Robson\'s accomplishments include designing a K-12 curricular innovation project, creating a post-secondary training and education program (P-STEP) for students with autism and intellectual disabilities, expanding opportunities for high school students with disabilities to participate in career and technical education (CTE) courses and paid internships, developing and implementing a district-wide strategy for aligning self-contained special education classrooms with high school feeder patterns, and partnering with DC Special Education Hub to develop a family empowerment video series.',
    social: {
      linkedin: '#'
    }
  },
  {
    name: 'Brian Merski',
    role: 'Programs Committee',
    image: "/assets/images/Screenshot_2026-01-27_at_2.11.26_PM-1769541092179.png",
    alt: 'Brian Merski, Programs Committee member specializing in youth STEM education',
    bio: 'Brian is a scientist with a specialty in youth education. After completing his degree in Psychology, Neuroscience, and Digital Studies at the University of Mary Washington, Merski furthered his technical skills as a Computer Technician before joining KID Museum. At KID, Brian works to educate children from underserved communities in STEM and SEL (social emotional learning) concepts in a makerspace environment. In his role, he prioritizes ensuring that children have the mental and physical tools to bring their creativity to life by providing a broad variety of STEM education. From programming robotics to engineering design and circuits, he has a comprehensive understanding of key STEM subjects and how to effectively teach them.',
    social: {
      linkedin: '#'
    }
  }];


  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-secondary/10 rounded-full mb-6">
            <Icon name="UserGroupIcon" size={20} className="text-brand-secondary" variant="solid" />
            <span className="text-sm font-semibold text-brand-secondary">Our People</span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6">Team & Board Members

          </h2>
          
          <p className="text-lg text-text-secondary max-w-3xl mx-auto mb-8">
            Meet the dedicated individuals leading our mission to end food deserts and empower communities.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {boardMembers.map((member, index) =>
          <div
            key={index}
            className="bg-white rounded-2xl overflow-hidden shadow-brand-md hover:shadow-brand-lg transition-all duration-300 group cursor-pointer"
            onClick={() => setSelectedMember(member)}>

              <div className="relative h-80 overflow-hidden">
                {member.image ?
              <>
                    <AppImage
                  src={member.image}
                  alt={member.alt}
                  quality={100}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </> :

              <div className="w-full h-full bg-white" />
              }
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-text-primary mb-1">{member.name}</h3>
                <p className="text-brand-primary font-semibold mb-4">{member.role}</p>
                
                <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedMember(member);
                }}
                className="w-full px-4 py-2 bg-brand-primary text-white rounded-lg font-semibold hover:bg-brand-primary/90 transition-all duration-300 mb-4">

                  Read Bio
                </button>
                
                <div className="flex gap-3">
                  {member.social.linkedin &&
                <a
                  href={member.social.linkedin}
                  className="w-10 h-10 bg-surface rounded-lg flex items-center justify-center hover:bg-brand-primary hover:text-white transition-all duration-300"
                  onClick={(e) => e.stopPropagation()}>

                      <Icon name="LinkIcon" size={20} />
                    </a>
                }
                  {member.social.twitter &&
                <a
                  href={member.social.twitter}
                  className="w-10 h-10 bg-surface rounded-lg flex items-center justify-center hover:bg-brand-primary hover:text-white transition-all duration-300"
                  onClick={(e) => e.stopPropagation()}>

                      <Icon name="AtSymbolIcon" size={20} />
                    </a>
                }
                  {member.social.email &&
                <a
                  href={`mailto:${member.social.email}`}
                  className="w-10 h-10 bg-surface rounded-lg flex items-center justify-center hover:bg-brand-primary hover:text-white transition-all duration-300"
                  onClick={(e) => e.stopPropagation()}>

                      <Icon name="EnvelopeIcon" size={20} />
                    </a>
                }
                </div>
              </div>
            </div>
          )}
        </div>

        {selectedMember &&
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedMember(null)}>

            <div
            className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-brand-lg"
            onClick={(e) => e.stopPropagation()}>

              <div className="relative h-96 overflow-hidden">
                {selectedMember.image ?
              <AppImage
                src={selectedMember.image}
                alt={selectedMember.alt}
                className="w-full h-full object-cover" /> :

              <div className="w-full h-full bg-white" />
              }

                <button
                onClick={() => setSelectedMember(null)}
                className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-surface transition-colors duration-300">

                  <Icon name="XMarkIcon" size={24} />
                </button>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-text-primary mb-1">{selectedMember.name}</h3>
                <p className="text-brand-primary font-semibold text-lg mb-6">{selectedMember.role}</p>
                
                <p className="text-text-secondary leading-relaxed mb-6">{selectedMember.bio}</p>
                
                <div className="flex gap-3 pt-6 border-t border-border">
                  {selectedMember.social.linkedin &&
                <a
                  href={selectedMember.social.linkedin}
                  className="flex-1 px-4 py-3 bg-surface rounded-lg flex items-center justify-center gap-2 hover:bg-brand-primary hover:text-white transition-all duration-300">

                      <Icon name="LinkIcon" size={20} />
                      <span className="font-semibold">LinkedIn</span>
                    </a>
                }
                  {selectedMember.social.email &&
                <a
                  href={`mailto:${selectedMember.social.email}`}
                  className="flex-1 px-4 py-3 bg-surface rounded-lg flex items-center justify-center gap-2 hover:bg-brand-primary hover:text-white transition-all duration-300">

                      <Icon name="EnvelopeIcon" size={20} />
                      <span className="font-semibold">Email</span>
                    </a>
                }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </section>);

}